import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import EditRoleModal from './EditRoleModal';
import CreateRoleModal from './CreateRoleModal';
import ReactPaginate from 'react-paginate';
import { UserContext } from '../../../contexts/UserContext';

const Roles = () => {
    const [roles, setRoles] = useState([]);
    const [permissionsMap, setPermissionsMap] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const { user } = useContext(UserContext);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const rolesPerPage = 10; // Adjust the number of roles per page

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const permissionsCollection = collection(db, 'permissions');
                const permissionsSnapshot = await getDocs(permissionsCollection);
                const permissionsList = permissionsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                const permissionsMap = permissionsList.reduce((map, permission) => {
                    map[permission.id] = permission.nom;
                    return map;
                }, {});
                setPermissionsMap(permissionsMap);
            } catch (error) {
                console.error("Error fetching permissions: ", error);
            }
        };

        const fetchRoles = async () => {
            try {
                const rolesCollection = collection(db, 'roles');
                const rolesSnapshot = await getDocs(rolesCollection);
                const rolesList = rolesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setRoles(rolesList);
            } catch (error) {
                console.error("Error fetching roles: ", error);
            }
        };

        fetchPermissions();
        fetchRoles();
    }, []);

    // Calculate pagination data
    const indexOfLastRole = (currentPage + 1) * rolesPerPage;
    const indexOfFirstRole = indexOfLastRole - rolesPerPage;
    const currentRoles = roles.slice(indexOfFirstRole, indexOfLastRole);
    const pageCount = Math.ceil(roles.length / rolesPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleShowEdit = (role) => {
        setSelectedRole(role);
        setShowEditModal(true);
    };

    const handleSaveEdit = async (updatedRole) => {
        try {
            const roleDoc = doc(db, 'roles', updatedRole.id);
            await updateDoc(roleDoc, updatedRole);
            setRoles(prevRoles =>
                prevRoles.map(r =>
                    r.id === updatedRole.id ? updatedRole : r
                )
            );
        } catch (error) {
            console.error("Error updating role: ", error);
        }
    };

    const handleSaveCreate = (newRole) => {
        setRoles(prevRoles => [...prevRoles, newRole]);
    };

    const handleDeleteRole = async (roleId) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce rôle ?")) {
            try {
                await deleteDoc(doc(db, 'roles', roleId));
                setRoles(prevRoles => prevRoles.filter(role => role.id !== roleId));
            } catch (error) {
                console.error("Error deleting role: ", error);
            }
        }
    };

    const getPermissionName = (permissionId) => {
        return permissionsMap[permissionId] || 'Unknown';
    };

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                  
                    <br/>
                    {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                    <button className="btn btn-org mb-4" onClick={() => setShowCreateModal(true)}>
                        <FontAwesomeIcon icon={faPlus} /> Ajouter un rôle
                    </button>
                    )}
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold title-2">Rôles </h6>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Nom</th>
                                            <th>Permissions</th>
                                            {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                            <th>Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRoles.map((role) => (
                                            <tr key={role.id}>
                                                <td>{role.nom}</td>
                                                <td>
                                                    <ul>
                                                        {role.permissions.map((permissionId, index) => (
                                                            <li key={index}>{getPermissionName(permissionId)}</li>
                                                        ))}
                                                    </ul>
                                                </td>
                                                {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                <td>
                                                    <button className="btn btn-primary btn-circle btn-sm mr-2" onClick={() => handleShowEdit(role)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button className="btn btn-danger btn-circle btn-sm" onClick={() => handleDeleteRole(role.id)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-start'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedRole && (
                <EditRoleModal
                    show={showEditModal}
                    handleClose={() => setShowEditModal(false)}
                    role={selectedRole}
                    handleSave={handleSaveEdit}
                />
            )}
            <CreateRoleModal
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                handleSaveCreate={handleSaveCreate}
                permissionsMap={permissionsMap}
            />
        </div>
    );
};

export default Roles;
